import MultiSwitchDisclosure from "@pathwright/ux/src/components/form/MultiSwitchDisclosure"
import { TipId, TipStatus } from "../../../tips/types"
import useTipStatus from "../../../tips/useTipStatus"

// For viewing Home tips regardless of conditions.
function HomeSuperUserAugmentationTips() {
  const tipsSetStatus = {} as Record<TipId, ReturnType<typeof useTipStatus>[1]>

  const multiOptions = [
    {
      field: "home-welcome-all-transitional-blank-slate",
      label: "Welcome All Transitional Blank Slate",
      value: getValue(
        useTipStatus("home-welcome-all-transitional-blank-slate")[0]
      )
    },
    {
      field: "home-welcome-designer-blank-slate",
      label: "Welcome Designer Blank Slate",
      value: getValue(useTipStatus("home-welcome-designer-blank-slate")[0])
    },
    {
      field: "home-welcome-member-blank-slate",
      label: "Welcome Member Blank Slate",
      value: getValue(useTipStatus("home-welcome-member-blank-slate")[0])
    },
    {
      field: "home-set-aside-paths",
      label: "Set Aside Paths",
      value: getValue(useTipStatus("home-set-aside-paths")[0])
    }
  ] as const

  const tipIds = multiOptions.map((option) => option.field)

  for (let i = 0; i < tipIds.length; i++) {
    const tipId = tipIds[i]
    tipsSetStatus[tipId] = useTipStatus(tipId)[1]
  }

  function getValue(status?: TipStatus) {
    return !!status && status !== "dismissed"
  }

  return (
    <MultiSwitchDisclosure
      singularOption={{
        icon: "info-circle",
        field: "toggle_tips",
        label: "Toggle Tips"
      }}
      multiOptions={multiOptions}
      onSubmit={(values) => {
        Object.entries(values).forEach(([tipId, value]) => {
          const setStatus = tipsSetStatus[tipId as TipId]
          const status = value ? "expanded" : "dismissed"
          setStatus(status)
        })
      }}
    />
  )
}

export default HomeSuperUserAugmentationTips
